import React, { useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { InputField } from '../../../../../components/formFields/InputField';
import Label from '@/components/Label';
import { AreaField } from '../../../../../components/formFields/AreaField';

type HasValueModalProps = {
  visible: boolean;
  title: string;
  onSubmit: (values: any) => void;
  onClose: () => void;
};

const HasValueModal = ({ visible, title, onSubmit, onClose }: HasValueModalProps) => {
  const ValidationSchema = Yup.object().shape({
    value: Yup.string().nullable().required('Povinné pole'),
    description: Yup.string().nullable().required('Povinné pole'),
  });

  const formRef = useRef<any>(null);

  const onSubmitButton = () => {
    if (!formRef?.current) return null;
    formRef.current.submitForm();
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Formik
            innerRef={formRef}
            enableReinitialize={true}
            validationSchema={ValidationSchema}
            initialValues={{
              value: null,
              description: null,
            }}
            onSubmit={(values) => {
              onSubmit(values);
            }}
          >
            {(props) => {
              const { values } = props;
              return (
                <>
                  <Form>
                    <div className="space-y-1">
                      <div>
                        <Label name="value" title="Hodnota" required />
                        <Field
                          name="value"
                          value={values.value || null}
                          placeholder="Hodnota"
                          component={InputField}
                          data-testid="has-values-modal-value-input"
                        />
                      </div>

                      <div>
                        <Label name="description" title="Popisek" required />
                        <Field
                          name="description"
                          value={values.description || null}
                          placeholder="Popisek"
                          component={AreaField}
                          data-testid="has-values-modal-description-input"
                        />
                      </div>
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            onClick={() => onClose()}
            data-testid="has-values-modal-close-btn"
          >
            Zavřít
          </Button>
          <Button
            key={2}
            onClick={() => onSubmitButton()}
            data-testid="has-values-modal-submit-btn"
          >
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default HasValueModal;
